import React, { useEffect, useState } from 'react';
import { getItemBIDs } from '../../Services/Tura.api.service';
import { ItemBID as ItemBIDModel } from '../../Types/ItemBID';
import { translate } from '../../Services/translation';
import QuantityInput from '../QuantityInput/QuantityInput';
import BuyButton from '../BuyButton/BuyButton';
import { add } from '../../Services/Cart.service';
import {
  receive,
  triggerAddToCartAnimation,
} from '../../Actions/Cart.action';
import { useDispatch } from 'react-redux';
import { useTypedSelector } from '../../Hooks/useTypedSelector';

const ProductPageItemBIDs = ({
  articleNumber,
}: {
  articleNumber: string;
}) => {
  const dispatch = useDispatch();
  const [items, setItems] = useState<ItemBIDModel[] | undefined>();
  const { quantity: cartQuantity } = useTypedSelector(
    (state) => state.cart
  );

  useEffect(() => {
    (async () => {
      const items = await getItemBIDs(articleNumber);
      setItems(items);
    })();
  }, [articleNumber]);

  return (
    <>
      {items?.map((item, idx) => (
        <ItemBID
          key={`${item.promotionCode}-${idx}`}
          item={item}
          onBuyClick={async (item, quantity) => {
            const cart = await add({
              articleNumber: item.itemNo,
              quantity,
              promotionCode: item.promotionCode,
            });
            dispatch(receive(cart));
            if (cartQuantity != cart.quantity) {
              dispatch(triggerAddToCartAnimation());
            }
          }}
        />
      ))}
    </>
  );
};

const ItemBID = ({
  item,
  onBuyClick,
}: {
  item: ItemBIDModel;
  onBuyClick: (item: ItemBIDModel, quantity: number) => void;
}) => {
  const [quantity, setQuantity] = useState(1);

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center justify-between bg-black px-2 py-1.5 text-md text-white">
        <span>
          BID {item.promotionCode} / {item.description}
        </span>
        <span>
          {translate('product-page.item-bid.expiration-date')}:{' '}
          {item.endingDate}
        </span>
      </div>
      <div className="flex flex-col justify-between gap-y-2 xl:flex-row xl:items-center">
        <div className="flex flex-col gap-x-4 gap-y-2 sm:flex-row">
          <h4 className="mr-auto self-center xl:mr-0">
            {item.formattedUnitPrice}
          </h4>
          <div className="flex gap-2">
            <QuantityInput
              step={1}
              quantity={quantity}
              min={1}
              max={item.maximumQuantity - item.usedQuantity}
              packagingSize={1}
              disabled={item.maximumQuantity - item.usedQuantity <= 0}
              onChange={setQuantity}
              showButtons={true}
              wrapperClassName="lg:min-w-[150px] min-w-[135px] [&_.relative]:flex-1"
            />
            <BuyButton
              showQuantityInput={false}
              packagingSize={1}
              onClick={() => onBuyClick(item, quantity)}
              articleNumber={item.itemNo}
              disabled={
                quantity <= 0 ||
                item.maximumQuantity - item.usedQuantity <= 0
              }
              className="flex-1 sm:flex-auto"
              btnClassName="btn--bid flex-1 sm:flex-auto"
            />
          </div>
        </div>
        <div>
          <div>
            <span className="text-md font-bold">
              {translate('product-page.item-bid.used')}:{' '}
            </span>
            {item.usedQuantity} {translate('general.of')}{' '}
            {item.maximumQuantity}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductPageItemBIDs;
